export default __webpack_public_path__ + "static/media/calendar-email-campaign.0924e990.svg";